import controller from './vd-segcontrol.controller'
import panelTemplate from './vd-segcontrol-panel.html'
import template from './vd-segcontrol.html'

const SegcontrolComponent = {
  bindings: {
    click: '=',
    disabled: '=',
    label: '=',
    // model is for easier backward compatibility, from before we had vd-segcontrol-group.
    _model: '=?model',
    value: '=',
  },
  require: {
    vdSegcontrolGroup: '?^vdSegcontrolGroup',
  },
  transclude: true,
  template($attrs) {
    'ngInject'
    if ($attrs.modifier === 'panel') {
      return panelTemplate
    } else {
      return template
    }
  },
  controller,
}

export default SegcontrolComponent
